import { Injectable, Inject, Optional } from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  private isLoaded = false;

  constructor(
    @Optional() @Inject('googleTagManagerId') private gtmId: string
  ) {
    if (this.gtmId) {
      this.initialize();
    }
  }

  private initialize(): void {
    if (this.isLoaded || !this.gtmId) {
      return;
    }

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    // Create GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}`;

    // Push initial config
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    // Insert script into DOM
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    this.isLoaded = true;
  }

  /**
   * Push a tag/event to the dataLayer
   * @param tag - Object containing event data to push to GTM
   */
  pushTag(tag: { event: string; [key: string]: any }): void {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.push(tag);
  }

  /**
   * Get the GTM ID
   */
  getGtmId(): string | null {
    return this.gtmId || null;
  }
}
